import { createSlice } from '@reduxjs/toolkit';
const SLICE_NAME = 'buyPremiumModalSlice';

export const buyPremiumModalSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        isOpen: false,
    },
    reducers: {
        toggleBuyPremiumModal(state) {
            state.isOpen = !state.isOpen;
        },
    },
});

export const { toggleBuyPremiumModal } = buyPremiumModalSlice.actions;

export const buyPremiumModalStateSelector = (state) => state.buyPremiumModal.isOpen;

export const buyPremiumModal = buyPremiumModalSlice.reducer;
